import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Blog.css";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/blogs/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Blogs API Response:", data); // Debug log

      // Handle different response structures
      if (Array.isArray(data)) {
        setBlogs(data);
      } else if (data.results && Array.isArray(data.results)) {
        setBlogs(data.results);
      } else {
        setBlogs([]);
      }
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteBlog = async (blogId) => {
    if (!blogId) {
      setError("Invalid blog ID");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        `https://ambatturindustrialestate.com/api/api/blogs/${blogId}/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        setBlogs(blogs.filter((blog) => blog.id !== blogId));
        setError(null);
      } else {
        throw new Error("Failed to delete blog");
      }
    } catch (err) {
      console.error("Error deleting blog:", err);
      setError(err.message);
    }
  };

  if (loading) return <div className="blog-loading">Loading blogs...</div>;
  if (error) return <div className="blog-error">Error: {error}</div>;

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1>Blog Management</h1>
        <Link to="/blogs/create" className="blog-create-btn">
          Create New Blog
        </Link>
      </div>

      <div className="blog-grid">
        {blogs.length === 0 ? (
          <div className="blog-empty">
            <p>No blogs found. Create your first blog!</p>
          </div>
        ) : (
          blogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              <div className="blog-image">
                {blog.image ? (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                ) : null}
                <div
                  className="blog-image-placeholder"
                  style={{ display: blog.image ? "none" : "flex" }}
                >
                  No Image
                </div>
              </div>

              <div className="blog-content">
                <h3 className="blog-title">{blog.title || "Untitled Blog"}</h3>
                <p className="blog-category">
                  Category:{" "}
                  {blog.category_name || blog.category || "Uncategorized"}
                </p>
                <p className="blog-author">By: {blog.author || "Unknown"}</p>
                <p className="blog-description">
                  {blog.description
                    ? `${blog.description.substring(0, 100)}...`
                    : "No description available"}
                </p>
                <div className="blog-actions">
                  <Link
                    to={`/blogs/edit/${blog.blog_id}`}
                    className="blog-edit-btn"
                  >
                    Edit
                  </Link>
                  <button
                    onClick={() => deleteBlog(blog.blog_id)}
                    className="blog-delete-btn"
                  >
                    Delete
                  </button>
                  <Link
                    to={`/blogs/${blog.blog_id}`}
                    className="blog-view-btn"
                    onClick={() => console.log("Blog clicked:", blog.blog_id)}
                  >
                    View
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlogList;
